import { articles } from "virtual:ga-articles";
import { isPublishedByDate } from "@general-applications/contracts/content";
import type { BlogPostSummary } from "@general-applications/contracts/content";
import { isDevMode } from "@/app/common/functions/env/isDevMode";

export type * from "@general-applications/contracts/content";
export {
  calculateReadingTime,
  isPublishedByDate,
  isPublicBlogPost,
  sortBlogPosts,
} from "@general-applications/contracts/content";
export function isPreviewableBlogPost(post: BlogPostSummary): boolean {
  return isDevMode() || isPublishedByDate(post);
}

export const blogIndexPage = {
  seoTitle: "Blog | General Applications",
  seoDescription:
    "Technical articles, opinions, and observations on AI, software architecture, metadata search relevance, and pipeline engineering.",
  headline: "Technical Articles & Applied Opinions",
  heroImage: "/images/brand/blog-hero.webp",
  heroCopy: [
    "Engineering perspectives on wrapping probabilistic systems in deterministic controls, structuring search relevance, and maintaining data pipeline integrity.",
  ],
};

export const blogPosts: BlogPostSummary[] = articles;

export const articleLoadError = {
  title: "This article could not be loaded.",
  description: "Please try loading the page again.",
  retry: "Reload this page",
};
